module.exports = __webpack_public_path__ + "img/facephoto.61ffaeb1.webp";